import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Helpers } from "./helpers";

@Component({
    standalone: false,
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    title = 'app';
    globalBodyClass = 'm-page--fluid m--skin- m-content--skin-light2 m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';

    constructor(private _router: Router) {
    }

    ngOnInit() {
        // The static index page shows the loader while Angular and Keycloak
        // bootstrap. Initial navigation may start before this subscription is
        // registered, so always clear that initial state once the app exists.
        Helpers.setLoading(false);

        this._router.events.subscribe((route) => {
            if (route instanceof NavigationStart) {
                Helpers.bodyClass(this.globalBodyClass);
                Helpers.setLoading(true);
            }
            if (route instanceof NavigationEnd || route instanceof NavigationCancel || route instanceof NavigationError) {
                Helpers.setLoading(false);
            }
        });

        this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                const currentRoute = event.urlAfterRedirects.split('/')[2];
                if (currentRoute !== 'locations') {
                    localStorage.removeItem('to_redirect');
                }
            }
        });
    }
}
